import React, { useEffect, useState } from 'react';
import {
    Modal, Box, Typography, IconButton, TextField, Button, Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import { CampaignList } from '../../../interfaces/Flowbuilder.interface.ts';
import { CampaignListActions, FlowBuilderActions } from '../../../Services/_actions/index.js';

interface CreatEditMappingModalProps {
    open: boolean;
    onClose: () => void;
    selectedRow?: any;
    handleConfirmSubmit?: () => void;
    parentCampaign?: any;
    childCampaign?: any;
    setChildCampaign: (value) => void;
    setDescription: (value) => void;
    description?: string;
    editIndex?: any;
}

const CreatEditMappingModal: React.FC<CreatEditMappingModalProps> = ({
    open,
    onClose,
    selectedRow,
    parentCampaign = null,
    childCampaign = null,
    setChildCampaign,
    description = "",
    setDescription,
    handleConfirmSubmit,
    editIndex = null,
}) => {
    const { showSnackBar } = useSnackBar();
    const campaignActions = CampaignListActions();
    const [filterForCamapign, setFilterForCamapign] = useState<{
        next_page: number;
        search: string;
        to: Number;
        include_assigned_by: Number;
        fetch_all: Number;
        organisationId: string;
    }>({
        to: 0,
        include_assigned_by: 0,
        fetch_all: 0,
        next_page: 1,
        search: '',
        organisationId: '',
    });
    const [isloading, setIsLoading] = useState(false);
    const [campaignList, setCampaignList] = useState<CampaignList>({ pages: 0, list: [] });
    const getCampaigns = async (filter) => {
        setFilterForCamapign({ ...filter });

        try {
            const res = await campaignActions.getCampaignAssignment(filter);

            if (res && typeof res === 'object' && Array.isArray(res.list)) {
                setCampaignList(res);
            } else {
                console.warn("Unexpected campaign response:", res);
                setCampaignList({ pages: 0, list: [] }); // fallback to safe default
            }
        } catch (error) {
            console.error("Failed to fetch campaigns:", error);
            setCampaignList({ pages: 0, list: [] }); // fallback to safe default
        }
    };

    const loadMoreOptions = async () => {
        if (filterForCamapign?.next_page <= campaignList?.pages) {
            if (filterForCamapign?.next_page > 1) {
                setIsLoading(true);
            }
            let listData = Array.isArray(campaignList?.list) ? [...campaignList?.list] : [];
            let data = { ...filterForCamapign, search: '', next_page: filterForCamapign?.next_page + 1 };
            setFilterForCamapign(data);

            let res = await campaignActions.getCampaignAssignment(data);
            if (Array.isArray(res?.list)) {
                listData = [...listData, ...res?.list];
            } else {
                showSnackBar('Received non-array response for campaign list.', 'error');
            }
            setCampaignList({ ...res, list: listData });
            setIsLoading(false);
        }
    };
    const handeSearchCampaign = (query) => {
        getCampaigns({ ...filterForCamapign, search: query || '', next_page: 1 });
    };


    useEffect(() => {
        getCampaigns(filterForCamapign);
    }, []);

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: '8px',
                    p: 3,
                    width: 400,
                    maxHeight: '90vh',
                    overflowY: 'auto',
                }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h6" fontWeight="bold">
                        {editIndex !== null ? "Edit" : "Add"} Child Campaign
                    </Typography>
                    <IconButton onClick={onClose}><CloseIcon /></IconButton>
                </Box>
                <SearchableDropdown
                    label="Parent Campaign"
                    options={campaignList?.list || []}
                    value={parentCampaign}
                    onSearch={handeSearchCampaign}
                    onChange={(value) => { console.log(value) }}
                    labelKey="name"
                    valueKey="proposal_id"
                    loading={isloading}
                    sx={{ marginBottom: 1 }}
                    fetchMoreOptions={campaignList?.has_next ? loadMoreOptions : undefined}
                    getOptionLabel={(option) =>
                        `${option?.name || 'Unnamed'} — ${option?.accountOrganisationName || ''}`
                    }
                    disabled
                />
                <SearchableDropdown
                    label="Select Child Campaign"
                    options={campaignList?.list.filter(
                        (c) => c.proposal_id !== parentCampaign?.proposal_id
                    )}
                    onSearch={handeSearchCampaign}
                    loading={isloading}
                    labelKey="name"
                    valueKey="proposal_id"
                    value={childCampaign}
                    onChange={(val) => setChildCampaign(val)}
                    fetchMoreOptions={campaignList?.has_next ? loadMoreOptions : undefined}
                    // getOptionLabel={(option) =>
                    //     `${option?.name || 'Unnamed'} — ${option?.accountOrganisationName || ''}`
                    // }
                    size="small"
                    sx={{ pb: 1 }}
                />

                <TextField
                    label="Description"
                    fullWidth
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    size="small"
                    multiline
                    rows={2}
                    placeholder="e.g., Handles service requests"
                />
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button onClick={onClose} size='small'>Cancel</Button>
                    <Button onClick={handleConfirmSubmit} size='small' variant="contained">Submit</Button>
                </Box>

            </Box>
        </Modal>
    );
};

export default CreatEditMappingModal;
